module.exports = __webpack_public_path__ + "static/media/logoutv2.9428a524.svg";